// extracted by mini-css-extract-plugin
module.exports = {"Golf__buttons":"Golf_Golf__buttons__1h3aB"};